import { render } from "./TermsOfUse.vue?vue&type=template&id=9f043136&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=9f043136&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f043136"]])

export default __exports__